import gql from 'graphql-tag'

const FETCH_EMAIL_BODY = gql`
  query getEmailBody($id: String!) {
    getEmailBody(id: $id)
  }
`;

export default FETCH_EMAIL_BODY
